import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { Question } from '../../../../_models';

@Component({
  selector: 'app-question-type-true-false',
  templateUrl: './question-type-true-false.component.html',
  styleUrls: ['./question-type-true-false.component.scss']
})
export class QuestionTypeTrueFalseComponent implements OnInit {

  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup; settings: Settings;
  @Input('viewOnly') viewOnly = false;

  constructor(
    private fb: FormBuilder,
    public appSettings: AppSettings,
  ) {
    this.settings = this.appSettings.settings;
  }

  get trueFalseAnswer() {
    return this.formGroup ? this.formGroup.get('trueFalseAnswer') : null;
  }

  ngOnInit() {
    this.formGroup.addControl('trueFalseAnswer',
      this.fb.control(this.question ? this.question.trueFalseAnswer : '', [Validators.required]));

    if (this.viewOnly)
      this.formGroup.disable();
  }
}
